import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

const Testimonials = ({ onShowInterest }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Aaliyah',
      image: '/images/avater.png',
      text: 'Finally a safe space where i can talk about cramps and my prayer schedule without feeling awkward. This app has changed how i view my monthly cycle entirely.'
    },
    {
      id: 2,
      name: 'Fatima',
      image: '/images/avater.png',
      text: 'This app understands the unique challenges Muslim women face. It has helped me balance my spiritual practices with my cycle in a way that feels natural and empowering.'
    },
    {
      id: 3,
      name: 'Zainab',
      image: '/images/avater.png',
      text: 'I love how this app combines faith with wellness. The reminders and insights are exactly what I needed to feel more connected to both my body and my practice.'
    },
    {
      id: 4,
      name: 'Aisha',
      image: '/images/avater.png',
      text: 'The community support here is incredible. I never knew how much I needed this until I found it. Thank you for creating such a safe and welcoming space.'
    },
    {
      id: 5,
      name: 'Mariam',
      image: '/images/avater.png',
      text: 'Tracking my cycle while staying true to my faith has never been easier. This app respects my values and helps me stay healthy at the same time.'
    }
  ];

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  // Calculate position class for each testimonial based on active index
  const getPositionClass = (testimonialIndex) => {
    const totalSlides = testimonials.length;
    let offset = testimonialIndex - activeIndex;
    
    // Normalize offset to be between -2 and 2
    if (offset > 2) offset -= totalSlides;
    if (offset < -2) offset += totalSlides;
    
    if (offset === 0) return 'active';
    if (offset === -1) return 'left-1';
    if (offset === -2) return 'left-2';
    if (offset === 1) return 'right-1';
    if (offset === 2) return 'right-2';
    return 'hidden';
  };

  return (
    <section id="community" className="testimonials-section">
      <Container>
        <h2 className="testimonials-title text-center">Voices from the Circle</h2>
      </Container>

      {/* CAROUSEL WITH BUTTONS */}
      <div className="testimonials-carousel-wrapper">
        <Container className="position-relative">
          {/* LEFT BUTTON */}
          <button 
            className="carousel-nav-btn carousel-nav-left"
            onClick={handlePrev}
            aria-label="Previous testimonial"
          >
            <BsChevronLeft size={24} />
          </button>

          {/* SLIDER - Render ALL testimonials */}
          <div className="testimonials-slider">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id}
                className={`testimonial-slide ${getPositionClass(index)}`}
              >
                <div className="testimonial-content">
                  <div className="testimonial-avatar">
                    <img src={testimonial.image} alt={testimonial.name} />
                  </div>
                  <h3 className="testimonial-name">{testimonial.name}</h3>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT BUTTON */}
          <button 
            className="carousel-nav-btn carousel-nav-right"
            onClick={handleNext}
            aria-label="Next testimonial"
          >
            <BsChevronRight size={24} />
          </button>
        </Container>
      </div>

      <Container>
        <div className="testimonials-cta text-center">
          <Button 
            className="btn-join-waitlist" 
            onClick={onShowInterest}
          >
            Join Waitlist
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default Testimonials;